import React from "react";

import { Box } from "@material-ui/core";

import grandataLogo from "assets/logos/grandata/gdt-color@2x.dca6cbc0.png";
import undpLogo from "assets/logos/undp/UNP-RBLAC-UNDP-no-tagline.png";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  grandata: {
    height: 42,
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      height: 32,
      padding: 6,
    },
  },
  unpd: {
    height: 60,
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      height: 48,
      padding: 6,
    },
  },
}));

export default function Credits() {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignContent="center"
      alignItems="center"
    >
      <a
        href="https://www.grandata.com"
        target="_blank"
        rel="noreferrer noopener"
      >
        <img className={classes.grandata} src={grandataLogo} alt="Grandata" />
      </a>
      <a href="https://www.undp.org/" target="_blank" rel="noreferrer noopener">
        <img
          className={classes.unpd}
          src={undpLogo}
          alt="United Nations Development Programme"
        />
      </a>
    </Box>
  );
}
